/**
 * Charms drawer (snippets/charms-drawer.liquid).
 *
 * Opens on the gallery pill (.charm-pill / [data-charms-open], see
 * snippets/charm-pill.liquid) and slides in from the right with every charm of
 * the PDP's custom.charms metafield as a product card.
 *
 * No cart action of its own: image paging comes from card-gallery and quick-buy
 * from the card's own controls, which drive the global quick-add drawer.
 */
(function () {
  const BODY_OPEN_CLASS = 'charms-drawer-open';

  class CharmsDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.charms-drawer');

      this.onDocClick = this.onDocClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    onDocClick(e) {
      const opener = e.target.closest('[data-charms-open]');
      if (opener) {
        e.preventDefault();
        this.open();
        return;
      }

      const closer = e.target.closest('[data-charms-close]');
      if (closer && this.contains(closer)) {
        e.preventDefault();
        this.close();
      }
    }

    onKeydown(e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && this.hasAttribute('open')) {
        this.close();
      }
    }

    open() {
      if (this.hasAttribute('open')) return;
      this.setAttribute('open', '');
      document.body.classList.add(BODY_OPEN_CLASS);
      if (this.dialog) this.dialog.focus();
    }

    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      document.body.classList.remove(BODY_OPEN_CLASS);
    }
  }

  if (!customElements.get('charms-drawer')) {
    customElements.define('charms-drawer', CharmsDrawer);
  }
})();
